<template>
	<b-form
		ref="form"
		@submit.prevent="add"
	>
		<b-row class="mt-3">
			<b-col cols="12">
				<b-form-group
					label="Name:"
					for="name"
				>
					<b-input
						id="name"
						v-model="component.Name"
						type="text"
						
						required
					/>
				</b-form-group>
			</b-col>

			

			<b-col cols="4">
				<b-button
					type="submit"
					variant="info"
				>
					Add
				</b-button>
			</b-col>

			<b-col cols="6">
				<span
					class="text-danger"
					v-if="postError"
				>{{ postError }}</span>
			</b-col>

		</b-row>

	</b-form>
</template>


<script>
import EquipmentService from "@/api-services/equipment.service";

export default {
	name: "AddEquipment",

	// things we have inherited from our parent
	props: [],

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			component: {
				Name: "",
				
			},
			postError: "",
		};
	},

	// things we do to data
	methods: {
		add() {
			EquipmentService.create(this.component)
				.then((response) => {
					// push this sucka back to the parent
					let newComponent = response.data;
					this.$emit("addEquipment", newComponent);
				})
				.catch((error) => {
					this.postError = error.response.data.Message;
				});
		},

		formatter(value) {
			return value.toUpperCase();
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-equipment.vue